export default __webpack_public_path__ + "img/286e0dd9461191548ea873454d77c0e7.png";